import { useQuery, ApolloError } from '@apollo/client';
import { GET_HIRER_ACCOUNT } from 'src/App/components/HirerAdPriceLookup/query';
import { PriceVisibility, PricingModel } from 'src/App/utils/Product';

interface RequestedFlag {
  name: string;
  defaultValue: boolean;
}

const useHirerAccountData = (advertiserId?: string) =>
  useQuery(GET_HIRER_ACCOUNT, {
    variables: {
      advertiserId: advertiserId ? parseInt(advertiserId, 10) : undefined,
    },
    skip: !advertiserId,
  });

export function useHirerPriceVisibility(advertiserId?: string): {
  loading: boolean;
  data?: PriceVisibility;
  error?: ApolloError;
} {
  const { loading, data, error } = useHirerAccountData(advertiserId);
  if (loading || error || !data?.hirerAccount?.priceVisibility) {
    return { loading, data: PriceVisibility.SHOW_DISCOUNTED_PRICE, error };
  }

  return { loading, data: data.hirerAccount.priceVisibility, error };
}

export function useHirerPricingModel(advertiserId?: string): {
  loading: boolean;
  data?: PricingModel;
  error?: ApolloError;
} {
  const { loading, data, error } = useHirerAccountData(advertiserId);

  if (loading || error || !data?.hirerAccount?.pricingModel) {
    return { loading, error };
  }
  return {
    loading,
    data: data.hirerAccount.pricingModel,
  };
}
